import React, {useEffect, useState} from 'react';
import {Button, makeStyles, TableCell, TableHead, TableRow} from "@material-ui/core";
import {getScheduleByIdPunkt} from "@cabinet-packages/api/api";
import {ConfirmDialog, CustomDialog, LineDialog, Loading} from "@cabinet-packages/components";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import moment from 'moment';
import 'moment/locale/uk';
import IconButton from "@material-ui/core/IconButton";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {useDispatch, useSelector} from "react-redux";
import {addSelectedPunkt, getCatalog, getPunkts, getSchedule, loginClient, setAssayTime} from "@cabinet-packages/redux";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {isOrderedAssaysHasPunkts} from "@cabinet-packages/helpers";
import {useHistory} from "react-router-dom";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    autocompleteWrapper: {
        padding: '8px',
    },
    error: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        textAlign: 'center',
        color: theme.palette.error.light,
        fontWeight: 600,
        padding: '8px'
    },
    setDateWrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '8px',
        maxWidth: '900px',

        '@media (max-width: 900px)': {
            flexDirection: 'column',
            justifyContent: 'flex-start',
        },
    },
    month: {
        minWidth: '300px',
        height: '100px',
        padding: '8px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        border: `1px solid ${theme.palette.primary.main}`,
        fontSize: '2rem',
        cursor: 'pointer',
        transition: '.3s',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderRadius: '5px',
        color: theme.palette.primary.main,

        '&:hover': {
            transition: '.3s',
            color: theme.palette.secondary.main,
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },

        '@media (max-width: 900px)': {
            marginTop: '4px',
        },
    },
    selectedMonth: {

    },
    table: {
        tableLayout: 'fixed',
        maxWidth: '350px',
        textAlign: 'center',
        border: '1px solid rgba(0, 0, 0, 0.1)',

    },
    tableHeadMonthName: {
        textAlign: 'center',
    },
    dayCell: {
        border: '1px solid rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        transition: '.5s',
        cursor: 'pointer',
        background: theme.palette.secondary.main,
        fontWeight: 600,
        width: '50px',

        '&:hover': {
            background: theme.palette.primary.item,
            transition: '.5s',
        },
    },
    hourCell: {
        border: '2px solid white',
        textAlign: 'center',
        transition: '.5s',
        cursor: 'pointer',
        background: theme.palette.secondary.main,
        fontWeight: 600,
        padding: '16px 4px',

        '&:hover': {
            background: theme.palette.primary.item,
            transition: '.5s',
        },
    },
    hourCellActive: {
        border: '2px solid white',
        textAlign: 'center',
        transition: '.5s',
        cursor: 'default',
        background: theme.palette.primary.main,
        fontWeight: 600,
        padding: '16px 4px',
    },
    hourCellNotActive: {
        border: '2px solid white',
        textAlign: 'center',
        transition: '.5s',
        cursor: 'default',
        background: 'rgba(0, 0, 0, 0.1)',
        fontWeight: 600,
        padding: '16px 4px',
    },
    dayCellActive: {
        border: '1px solid rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        transition: '.5s',
        cursor: 'default',
        background: theme.palette.primary.main,
        fontWeight: 600,
        width: '50px',
    },
    dayCellLock: {
        border: '1px solid rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        cursor: 'default',
        background: 'rgba(0, 0, 0, 0.1)',
        fontWeight: 600,
        width: '50px',
    },
    tableCell: {
        padding: '16px 10px'
    },
    actionButtonContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        padding: '8px',
    },
    annotations: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
    annotationsTableDesktop: {
        border: '1px solid rgba(0, 0, 0, 0.1)',
        tableLayout: 'fixed',

        '@media (max-width: 900px)': {
            display: 'none',
        },
    },
    annotationsTableMobile: {
        border: '1px solid rgba(0, 0, 0, 0.1)',
        tableLayout: 'fixed',
        display: 'none',

        '@media (max-width: 900px)': {
            display: 'table',
        },
    },
    actionButton: {
        maxWidth: '300px',
        width: 196,
        margin: '8px auto',
    },
    orderActionButton: {
        width: '196px',
        marginTop: '8px',

        '@media (max-width: 1140px)': {
            width: '95%',
            margin: '4px auto',
        },
    },
}));

moment.locale('uk');
const ukMonths = ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень",
    "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"];

const AssaySchedulerTime = ({isComponentInShop, dataPickers}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const [selected, setSelected] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [userData, setUserData] = useState(null);
    const [months, setMonths] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedWorkDays, setSelectedWorkDays] = useState(null);
    const [monthDays, setMonthDays] = useState(null);
    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);
    const [open, setOpen] = useState(false);
    const {themeMaterialUI} = useSelector(state => state.theme);
    const {punkts} = useSelector(store => store.collectionPoints);
    const {selectedPunkt, orderingList} = useSelector(store => store.orderAssays);
    const { activePatient } = useSelector(store => store.patients);
    const { schedule } = useSelector(state => state.scheduleOfOrders);
    const {catalog, complexResearch, actions}  = useSelector(state => state.assaysCatalog);
    const [selectedSchedule, setSelectedSchedule] = useState(null);
    const [isUserConfirmTime, setIsUserConfirmTime] = useState(false);
    const [orderShow, setOrderShow] = useState(false);
    const [duration, setDuration] = useState(null);
    const [isUserTap, setIsUserTap] = useState(false);
    const [scheduleForSelectedDay, setScheduleForSelectedDay] = useState(null);

    const handleChoseAnotherMonth = (event, direction) => {
        event.preventDefault();
        event.stopPropagation();
        const indexOfSelectedMonth = months.indexOf(selectedMonth);

        if (months.length === 1) return;

        if (direction === 'back') {
            if (indexOfSelectedMonth === 0) {
                setSelectedMonth(months[months.length - 1]);
            } else {
                setSelectedMonth(months[indexOfSelectedMonth - 1]);
            }
        } else if (direction ==='forward') {
            if (indexOfSelectedMonth === months.length - 1) {
                setSelectedMonth(months[0]);
            } else {
                setSelectedMonth(months[indexOfSelectedMonth + 1]);
            }
        }

        setSelectedWorkDays(null);
        setMonthDays(null);
        setSelectedDay(null);
        setSelectedTime(null);
        setScheduleForSelectedDay(null);
    };

    const handleClickOnDay = (event, dayNum) => {
        event.preventDefault();
        event.stopPropagation();
        setScheduleForSelectedDay(null);

        const scheduleForSelectedDay = selectedWorkDays
            .filter(item => moment(item.dt_start).date() === dayNum)
            .sort((a, b) => {
                if (moment(a.dt_start).hour() > moment(b.dt_start).hour()) {
                    return 1;
                } else {
                    return -1
                }
            });

        const selectedDayAllWorkingTime = scheduleForSelectedDay.reduce((acu, cur, idx, src) => {
            if (src.length === 1) {
                return cur;
            }

            if (idx === 0) {
                return {...acu, dt_start: cur.dt_start, month: cur.month};
            } else if (idx === src.length - 1) {
                return {...acu, dt_end: cur.dt_end}
            } else {
                return acu;
            }
        }, {});

        setScheduleForSelectedDay(scheduleForSelectedDay);

        const selectedDay = {
            ...selectedDayAllWorkingTime,
            receptionHours: []
        };

        for (let i = moment(selectedDay.dt_start).hour(); i < moment(selectedDay.dt_end).hour(); i++) {
            for (let j = 0; j < 60; j+=duration) {
                selectedDay.receptionHours.push(j === 0 ? `${i}:00` : `${i}:${j}`)
            }
        }

        setSelectedDay({...selectedDay, receptionHours: selectedDay.receptionHours.reduce((acu, cur, idx) => {
                if (idx === 0) return [[cur]];
                if ((idx)%7 === 0) return [...acu, [cur]];
                acu[Math.ceil(((idx+1)/7)-1)] = [...acu[Math.ceil(((idx+1)/7)-1)], cur]
                return acu;
            }, [])});
        setSelectedTime(null);
    };

    const handleClickOnTime = (event, time) => {
        event.preventDefault();
        event.stopPropagation();
        setSelectedTime(time);
        CustomDialog(ConfirmDialog,
            {text: `Ви обрали запис на ${selectedDay.dt_start.slice(0, 10)} ${time} за адресою: ${selectedPunkt.address}. Підтвердити вибраний час?`,
                onCancel: () => {
                    setSelectedTime(null);
                },
                onConfirm:  () => {
                    dispatch(setAssayTime({date: `${selectedDay.dt_start.slice(0, 10)} ${time}`}));
                    setIsUserConfirmTime(true);
                    !activePatient && dispatch(loginClient(themeMaterialUI))
                }}, false,
            themeMaterialUI);
    };

    const handleClose = () => {
        setOpen(false);
        setIsUserTap(true);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleTransitionToLineRugPick = (point, isComponentInShop) => {
        CustomDialog(LineDialog,
            {point, isComponentInShop, history, themeMaterialUI},
            false,
            themeMaterialUI);
    };

    const handleChangePunkt = (event, value) => {
        event.stopPropagation();
        event.preventDefault();

        dispatch(addSelectedPunkt(value));
        setSelected(value);
        setUserData(null);
        setSelectedWorkDays(null);
        setMonthDays(null);
        setSelectedDay(null);
        setSelectedTime(null);
        setIsError(false);
        setSelectedSchedule(null);
        setSelectedMonth(null);
        setIsUserTap(true);
    };

    useEffect(() => {
        async function getUserData() {
            try {
                setIsLoading(true);
                const data = await getScheduleByIdPunkt(selectedPunkt.idPunkt);
                if (data && data.length === 1) {
                    setUserData(...data
                        .map(item => ({
                            ...item,
                            workHours: JSON.parse(item.workHours)
                                .map(item => ({...item, month: ukMonths[moment(item.dt_start).month()]}))}))
                    );
                } else if (data && data.length === 0) {
                    setIsError('Вибачте, для даного відділення попередній запис не проводиться. \n' + '<br/>'+
                        'Запрошуємо Вас у порядку живої черги у обраний Вами день! Дякуємо за розуміння :)\n')
                } else if (data === undefined) {
                    setIsError(true)
                } else {
                    setUserData(data);
                }
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                setIsError(error);
            }
        }
        if (!userData && !isError && selectedPunkt) {
            getUserData();
        }
        if (userData && !isError && !months) {
            setMonths(userData.workHours
                .sort((a, b) => a.dt_start.localeCompare(b.dt_start))
                .map(item => item.month)
                .reduce((acu, cur) => {
                    if (acu.includes(cur)) {
                        return acu;
                    }

                    return [...acu, cur];
            }, []));
        }
        if (!selectedMonth && months) {
            setSelectedMonth(months[0]);
        }

        if (selectedMonth && !selectedWorkDays && userData) {
            setSelectedWorkDays(userData.workHours.filter(item => item.month === selectedMonth));
        }
        if (selectedMonth && !monthDays) {
            const monthFirstDay = moment().month(selectedMonth).startOf('month').weekday();
            const lengthOfMonth = moment().month(selectedMonth).endOf('month').date();

            const arrayOfDays = [];
            for (let i = 0; i < monthFirstDay; i++) {
                arrayOfDays.push({dayNum: ''})
            }
            for (let i = 1; i <= lengthOfMonth; i++) {
                arrayOfDays.push({dayNum: i})
            }
            setMonthDays(arrayOfDays.reduce((acu, cur, idx) => {
                if (idx === 0) return [[cur]];
                if ((idx)%7 === 0) return [...acu, [cur]];
                acu[Math.ceil(((idx+1)/7)-1)] = [...acu[Math.ceil(((idx+1)/7)-1)], cur]
                return acu;
            }, []));
        }
        if (!punkts) dispatch(getPunkts());
        if (punkts && !selected && !selectedPunkt && !isUserTap) {
            setSelected(punkts[0]);
            dispatch(addSelectedPunkt(punkts[0]));
        }
        if (punkts && selectedPunkt && !selected) {
            setSelected(selectedPunkt)
        }
        if (!schedule) {
            dispatch(getSchedule());
        }
        if (schedule && selectedPunkt && !selectedSchedule) {
            setSelectedSchedule(schedule.filter(item => item.idPunkt === selectedPunkt.idPunkt).map(item => {
                if (item) {
                    const spitedDate = item.dt.split(' ');
                    const date = spitedDate[0].split('.');

                    return ({
                        ...item,
                        dt: `${date[2]}-${date[1]}-${date[0]} ${spitedDate[1]}`
                    })
                } else {
                    return item;
                }
            }))
        }
        if (activePatient && selectedTime && isUserConfirmTime) {
            if(dataPickers){
                setOrderShow(true)
            } else {
            isComponentInShop
                ? history.push('/shop-confirm-order')
                : history.push('/confirm-order')
            }
        }

        if (catalog && complexResearch && actions) {
            dispatch(getCatalog());
        }

        if (catalog && complexResearch && actions && !duration) {
            const durationOfAssays = [...catalog, ...actions, complexResearch]
                .filter(item => orderingList.find(assay => +item.id === assay.id && item.type === assay.type))
                .reduce((acu, cur) => {
                    if (acu > cur.duration_min) {
                        return acu;
                    } else {
                        return cur.duration_min;
                    }
                }, 0);

            setDuration(!!durationOfAssays ? durationOfAssays : 10);
        }
    }, [userData, isError, months, selectedMonth, selectedWorkDays, monthDays, selectedPunkt, punkts, dispatch,
        selected, selectedSchedule, activePatient, isUserConfirmTime, history, isComponentInShop, schedule,
        selectedTime, orderingList, duration, catalog, complexResearch, actions, isUserTap]);

    return (<div className={classes.root}>
        <div className={classes.autocompleteWrapper}>
            {<Autocomplete
                className={classes.autoComplete}
                id="combo-box"
                open={open}
                onOpen={handleOpen}
                onClose={handleClose}
                value={selected}
                freeSolo
                options={punkts
                    ? isOrderedAssaysHasPunkts()
                        ? isOrderedAssaysHasPunkts()
                        : punkts
                    : []}
                getOptionLabel={(option) => option.address}
                onChange={handleChangePunkt}
                style={{width: 300}}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Введіть назву пункту"
                        variant="outlined"
                    />)
                }
            />}
        </div>
        {!selected && !isLoading && !isError && isUserTap && <div className={classes.error}>Введіть адресу пункту або виберіть зі списку.</div>}
        {isLoading && <Loading/>}
        {isError && typeof isError === 'string' && <div className={classes.error}>
            <div className="content" dangerouslySetInnerHTML={{ __html: isError}}/>
            <Button
                className={classes.actionButton}
                variant="outlined"
                color="primary"
                onClick={() => handleTransitionToLineRugPick(selected, isComponentInShop)}
            >
                Обрати день візиту
            </Button>
        </div>}
        {isError && typeof isError !== 'string' && <div className={classes.error}>Вибачте, сталась помилка під час завантаження.</div>}
        <div className={classes.setDateWrapper}>
            {selectedMonth && selectedWorkDays && months && <div className={classes.selectedMonth}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            {months.length > 1 && <TableCell className={classes.tableCell}>
                                <IconButton
                                    size="small"
                                    onClick={event => handleChoseAnotherMonth(event, 'back')}
                                >
                                    <ArrowBackIcon/>
                                </IconButton>
                            </TableCell>}
                            <TableCell
                                colSpan={months.length > 1 ? 5 : 7}
                                className={classes.tableHeadMonthName}
                            >
                                {selectedMonth}
                            </TableCell>
                            {months.length > 1 && <TableCell className={classes.tableCell}>
                                <IconButton
                                    size="small"
                                    onClick={event => handleChoseAnotherMonth(event, 'forward')}
                                >
                                    <ArrowForwardIcon/>
                                </IconButton>
                            </TableCell>}
                        </TableRow>
                        <TableRow>
                            <TableCell>Пн</TableCell>
                            <TableCell>Вт</TableCell>
                            <TableCell>Ср</TableCell>
                            <TableCell>Чт</TableCell>
                            <TableCell>Пт</TableCell>
                            <TableCell>Сб</TableCell>
                            <TableCell>Нд</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {monthDays && selectedWorkDays && monthDays.map((week, idx) => {
                            return (<TableRow key={'week'+idx}>
                                {week.map((day, index) => {
                                    const isAvailableDay = selectedWorkDays
                                        .filter(item => +moment(item.dt_start).date() === +day.dayNum
                                            && moment().month(selectedMonth).month() === moment(item.dt_start).month())
                                        .reduce((acu, cur) => {
                                        if (selectedPunkt && selectedPunkt.idPunkt === 149 && moment(cur.dt_start).dayOfYear() === moment().dayOfYear()) return false;

                                        if (moment(cur.dt_start).dayOfYear() < moment().dayOfYear()) return false;
                                        if (moment(cur.dt_start).dayOfYear() === moment().dayOfYear() && moment(cur.dt_end).hour() < moment().hour()) return false;
                                        if (moment(cur.dt_start).date() === day.dayNum) return true;
                                        return acu;
                                    }, false);

                                    const isDayActive = selectedDay && (day.dayNum === moment(selectedDay.dt_start).date());


                                    return (<TableCell
                                        key={day.dayNum + '' + idx + '' + index}
                                        className={isAvailableDay
                                            ? isDayActive ? classes.dayCellActive : classes.dayCell
                                            : classes.dayCellLock}
                                        onClick={(event) => isAvailableDay && !isDayActive &&  handleClickOnDay(event, day.dayNum)}
                                    >
                                        {day.dayNum}
                                    </TableCell>);
                                })}
                            </TableRow>)
                        })}
                    </TableBody>
                </Table>
            </div>}
            {selectedDay && <div>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={7}>Оберіть зручний для вас час:</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {selectedDay.receptionHours.map((item, idx) => {
                            return (<TableRow key={'row'+idx}>
                                {item.map((time, index) => {
                                    const isSelectedTime = selectedTime === time;
                                    const isReservedTime = selectedSchedule && selectedSchedule.find(reserved => {
                                        if (moment(reserved.dt).dayOfYear() === moment(selectedDay.dt_start).dayOfYear()) {
                                            if (moment(reserved.dt).hour() === +time.split(':')[0]
                                                && (moment(reserved.dt).minute() === +time.split(':')[1]
                                                || (moment(reserved.dt).minute() >= +time.split(':')[1]
                                                    && moment(reserved.dt).minute() <= +time.split(':')[1]+10))
                                            ) {
                                                return true;
                                            }
                                        }
                                        return false;
                                    })

                                    const isHourGreaterThenNow = selectedDay
                                        && (moment(selectedDay.dt_start).dayOfYear() === moment().dayOfYear())
                                        && +time.split(':')[0] <= moment().hour();

                                    const isNotWorkingTime = scheduleForSelectedDay
                                        && scheduleForSelectedDay.length > 1
                                        && scheduleForSelectedDay.reduce((acu, cur, idx, src) => {
                                            if (idx === 0) {
                                                return acu;
                                            }
                                            if (moment(src[idx - 1].dt_end).hour() <= +time.split(':')[0] && moment(cur.dt_start).hour() > +time.split(':')[0]) {
                                                return true;
                                            } else {
                                                return acu;
                                            }
                                        }, false);

                                    const isVisitingPunkt = selectedPunkt.idPunkt === 149 && !time.includes(':00');

                                    return (<TableCell
                                        key={time + index}
                                        className={isSelectedTime
                                            ? classes.hourCellActive
                                            : isReservedTime || isNotWorkingTime || isVisitingPunkt
                                                ? classes.hourCellNotActive
                                                : isHourGreaterThenNow ? classes.hourCellNotActive : classes.hourCell
                                        }
                                         onClick={(event) => !isSelectedTime && !isReservedTime && !isHourGreaterThenNow && handleClickOnTime(event, time)}
                                    >
                                        {time}
                                    </TableCell>)
                                })}
                            </TableRow>)
                        })}
                    </TableBody>
                </Table>
            </div>}
        </div>
        {selectedMonth && selectedWorkDays && months && <div className={classes.annotations}>
            <Table className={classes.annotationsTableDesktop}>
                <TableBody>
                    <TableRow>
                        <TableCell className={classes.dayCellLock}/>
                        <TableCell>- вільних годин немає</TableCell>

                        <TableCell className={classes.dayCell}/>
                        <TableCell>- є вільні години</TableCell>

                        <TableCell className={classes.dayCellActive}/>
                        <TableCell>- вибраний час</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Table className={classes.annotationsTableMobile}>
                <TableBody>
                    <TableRow>
                        <TableCell className={classes.dayCellLock}/>
                        <TableCell>- вільних годин немає</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className={classes.dayCell}/>
                        <TableCell>- є вільні години</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className={classes.dayCellActive}/>
                        <TableCell>- вибраний час</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>}
        <Button
            variant="outlined"
            className={classes.orderActionButton}
            color="secondary"
            onClick={() => history.goBack()}
        >
            повернутись назад
        </Button>
    </div>);
};

export default AssaySchedulerTime;
